// Shared by the persona hero's "Video" hover pill (persona_portrait_actions_
// controller) and the customize-sheet's quick "Chat" button (persona_pane_
// switch_controller): both need to flip whichever of the two independent
// "chat is visible" mechanisms applies for the current layout — the desktop/
// tablet-touch pane switch (persona_layout.js) or the mobile sidebar collapse
// (jane_sidebar_controller.js). The other mechanism is a no-op when it
// doesn't apply, so calling both unconditionally is safe on every layout.
import { usesSidebarLayout } from "./layout_media"

export function openPersonaChatPane() {
    if (document.querySelector(".persona-workspace-toolbar")) {
        document.dispatchEvent(new CustomEvent("persona:open-chat"))
        return
    }
    document.querySelectorAll('[data-persona-pane="chat"]').forEach((input) => {
        if (input.checked) return
        input.checked = true
        input.dispatchEvent(new Event("change", { bubbles: true }))
    })
    // On phone portrait the detail sidebar does not exist as an overlay—the
    // product's supported chat surface is the full conversation page. An X
    // that only flips the desktop pane class looks active but does nothing, so
    // take the user to this persona's actual thread instead.
    if (!usesSidebarLayout()) {
        const sidebar = document.querySelector(".detail-sidebar--jane")
        const url = sidebar?.dataset.janeSidebarConversationUrlValue
        if (url) window.location.assign(url)
        return
    }

    if (document.documentElement.classList.contains("jane-sidebar-user-collapsed")) {
        document.dispatchEvent(new CustomEvent("jane-sidebar:toggle"))
    }
}
